const PencilIcon = ({ iconColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5984 0.0124023C19.3246 -0.0954861 21.0268 0.503894 22.3095 1.67868C23.4843 2.96135 24.0837 4.66359 23.9878 6.40179V17.5982C24.0957 19.3364 23.4843 21.0386 22.3215 22.3213C21.0388 23.4961 19.3246 24.0955 17.5984 23.9876H6.40184C4.66363 24.0955 2.96138 23.4961 1.67869 22.3213C0.503898 21.0386 -0.0954868 19.3364 0.0124024 17.5982V6.40179C-0.0954868 4.66359 0.503898 2.96135 1.67869 1.67868C2.96138 0.503894 4.66363 -0.0954861 6.40184 0.0124023H17.5984ZM10.7774 17.814L18.8451 9.72235C19.5763 8.97912 19.5763 7.78036 18.8451 7.04911L17.2867 5.49072C16.5434 4.74749 15.3447 4.74749 14.6014 5.49072L13.7983 6.30588C13.6784 6.42576 13.6784 6.62955 13.7983 6.74942C13.7983 6.74942 15.7043 8.64346 15.7403 8.69141C15.8721 8.83526 15.956 9.02707 15.956 9.24284C15.956 9.6744 15.6084 10.034 15.1649 10.034C14.9611 10.034 14.7693 9.95011 14.6374 9.81825L12.6354 7.82831C12.5395 7.73241 12.3717 7.73241 12.2758 7.82831L6.55769 13.5464C6.16209 13.942 5.93433 14.4694 5.92234 15.0329L5.85041 17.8739C5.85041 18.0298 5.89836 18.1736 6.00625 18.2815C6.11414 18.3894 6.25799 18.4493 6.41383 18.4493H9.23094C9.80635 18.4493 10.3578 18.2216 10.7774 17.814Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default PencilIcon;
